import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'
import '../../css/hero.css'

const carouselLength = document.querySelectorAll('.hero-carousel .swiper-slide').length

const heroCarousel = new Swiper('.hero-carousel', {
  loop: carouselLength > 1 ? true : false,
  autoplay: true,
  speed: 1000,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  on: {
    afterInit: function () {
      if (!this.slides.length > 0) return

      this.el.parentNode.querySelector('.hero__heading').textContent = getContent(
        this.slides[0],
        '.hero-slide__heading'
      ).label

      this.el.parentNode.querySelector('.hero__subheading').textContent = getContent(
        this.slides[0],
        '.hero-slide__subheading'
      ).label

      this.el.parentNode.querySelector('.pill-frosted__top').textContent = getContent(
        this.slides[0],
        '.hero-slide__caption__top'
      ).label
      this.el.parentNode.querySelector('.pill-frosted__bottom').textContent = getContent(
        this.slides[0],
        '.hero-slide__caption__bottom'
      ).label
    },
  },
})

const $section = heroCarousel.el.parentNode

heroCarousel.on('slideChange', function () {
  const currentSlide = this.slides[this.realIndex]

  const headings = {
    heading: {
      ...getContent(currentSlide, '.hero-slide__heading'),
    },
    subheading: {
      ...getContent(currentSlide, '.hero-slide__subheading'),
    },
  }

  const captions = {
    top: {
      ...getContent(currentSlide, '.hero-slide__caption__top'),
    },
    bottom: {
      ...getContent(currentSlide, '.hero-slide__caption__bottom'),
    },
  }

  $section.querySelector('.hero__heading').textContent = headings.heading.label
  $section.querySelector('.hero__subheading').textContent = headings.subheading.label
  $section.querySelector('.pill-frosted__top').textContent = captions.top.label
  $section.querySelector('.pill-frosted__bottom').textContent = captions.bottom.label
})

function getContent($currentSlide, element) {
  const $el = $currentSlide.querySelector(element)
  return {
    label: $el.textContent,
  }
}
